var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C5.60547 0 0 5.60547 0 12.5C0 19.3945 5.60547 25 12.5 25C19.3945 25 25 19.3945 25 12.5C25 5.60547 19.3945 0 12.5 0ZM12.5 23.4375C6.46973 23.4375 1.5625 18.5303 1.5625 12.5C1.5625 6.46973 6.46973 1.5625 12.5 1.5625C18.5303 1.5625 23.4375 6.46973 23.4375 12.5C23.4375 18.5303 18.5303 23.4375 12.5 23.4375ZM11.5625 17.7441L19.668 8.27148C19.9463 7.94434 19.9121 7.45117 19.5801 7.16309C19.248 6.88477 18.7549 6.92383 18.4766 7.25098L10.8887 16.123L6.44043 12.1826C6.11816 11.8994 5.625 11.9287 5.33691 12.251C5.05371 12.5732 5.08301 13.0664 5.40527 13.3545L10.4492 17.8223C10.5908 17.9492 10.7764 18.0176 10.9668 18.0176H11.0205C11.2305 18.0029 11.4258 17.9053 11.5625 17.7441Z",
    fill: "#38AE9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/green-tick-icon.e73176956eac375aaa89fc1b5a211664.svg";
export { ForwardRef as ReactComponent };